import {computed} from 'vue'
export default {
    name: "InStockLabel",
    props: {
        inStock: {
            required: true,
            default: 2
        },
        formatted: {
            required: true,
            default: ""
        },
        formattedAvailableDate: {
            required: false,
            default: ""
        }
    },
    setup(props){
        const inStock = computed(()=>props.inStock)
        const formatted = computed(()=>props.formatted)
        const formattedAvailableDate = computed(()=>props.formattedAvailableDate)
        return {
            inStock,
            formatted,
            formattedAvailableDate
        }
    }
}